export default '/build/45dc84d1.svg'